import React, { useEffect, useState, useRef } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from "primereact/skeleton";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { utils } from "../../../utils/index";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { Divider } from 'primereact/divider';
import { t } from "i18next";

const DepVsDealerManageGraph = () => {
    const fDate = new Date();
    fDate.setDate(fDate.getDate() - 5);
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [data, setData] = useState<any>([])
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [exportloading, setExportLoading] = useState(false)
    const [refreshState, setRefreshState] = useState<any>(new Date())
    const [loadingWebsite, setLoadingWebsite] = useState(true)
    const [hidebutton, setHideButton] = useState(true)
    useEffect(() => {
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    const toggleDarkMode = () => {
        setRefreshState(new Date()?.getTime())
    }
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }

    useEffect(() => {
        ApiCalls()
    }, [])

    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]
    const ApiCalls = async () => {
        loadWebsites()
    };


    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: "",
            websiteId: selectedWebsite?.websiteId,
            timeZone: "",
            timeType: "",
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
        };
    };
    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }

    const ExportPDF = async () => {
        setExportLoading(true)
        const element = document.getElementById('depManaged-report');
        if (element) {
            const pdf = new jsPDF();
            const sectionIds = ['section1', 'section2'];
            const logoWidth = 110;
            const logoHeight = 45;
            const logoY = 5;
            const logoX = 80;

            for (let i = 0; i < sectionIds.length; i++) {
                const sectionId = sectionIds[i];
                const section = document.getElementById(sectionId);

                if (i > 0) {
                    pdf.addPage();  // Add a new page for each section (except the first one)
                }

                // Draw the section content
                if (section) {
                    const canvas = await html2canvas(section);
                    const imgData = canvas.toDataURL('image/png');
                    pdf.addImage(imgData, 'PNG', 0, 25, pdf.internal.pageSize.getWidth(), 220);

                    if (sectionId == 'section1') {
                        const imageElement = document.getElementById('logoImage');
                        const imgDataUrl = imageElement?.getAttribute('src') || ''; // Get the image source URL

                        // Draw the logo on the first page
                        const canvasLogo = document.createElement('canvas');
                        const ctxLogo = canvasLogo.getContext('2d');

                        if (ctxLogo) {
                            const imgLogo = new Image();
                            imgLogo.src = imgDataUrl;
                            await new Promise(resolve => {
                                imgLogo.onload = () => {
                                    ctxLogo.drawImage(imgLogo, 0, 10, logoWidth, logoHeight);
                                    resolve(null);
                                };
                            });
                            const logoDataUrl = canvasLogo.toDataURL('image/png');
                            pdf.addImage(logoDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);
                        }
                    }
                }
            }
            pdf.save('DEP VS Dealer Managed (Graph).pdf');
        }
        setExportLoading(false)
    };

    const DepvsDealer_APi = async () => {
        var result = await wglcsApiService.depvsdealermanaged(commonRequestData())
        if (result.data.data) {
            setData(result.data.data)
            setLoading(false)
        }
    }
    const submit = () => {
        if (!selectedWebsite) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.website-validtion'))
            return;
        }
        else {
            setLoading(true)
            DepvsDealer_APi()
            setHideButton(false)
        }
    }
    const loadWebsites = async () => {
        let response = await wglcsApiService.getwebsitesfordepvsdealermanaged();
        var data = response.data.data
        setWebsiteArray(data)
        setLoadingWebsite(false)
    };
    const WebsiteOptionTemplate = (option) => {
        if (loadingWebsite) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.domainName}</div>
                </div>
            );
        }
    };
    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
    }

    const companyName = data?.map(m => m.companyName)
    const greetToVisitorRatio = data?.map(m => m.greetToVisitorRatio)
    const chatToVisitorRatio = data?.map(m => m.chatToVisitorRatio)
    const firstRespTime = data?.map(m => m.frt)
    const avgRespTime = data?.map(m => m.art)
    const avgLoggedinTime = data?.map(m => m.avgDayLoggedInTime)
    const timeoutchat = data.map(m => m.noResponseChats)
    const MeaningfulleadToContactsConversion = data?.map(m => m.leadToContactsConversion)
    const chatToLeadConversion = data?.map(m => m.chatToLeadConversion)

    const VisitortoGreetCoversion = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.VisitorGreet-Conversion'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName.map(m => m + " %"),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.VisitorGreet-Conversion'),
            data: greetToVisitorRatio,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const VisitortoChatConversion = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.VisitorChat-Conversion'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName.map(m => m + " %"),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.VisitorChat-Conversion'),
            data: chatToVisitorRatio,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const ChattoMeaningfulConversation = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.MeaningfulLeads-Conversion'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName.map(m => m + " %"),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.MeaningfulLeads-Conversion'),
            data: MeaningfulleadToContactsConversion,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const ChatToLeadConversion = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.ChatLead-Conversion'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName.map(m => m + " %"),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.ChatLead-Conversion'),
            data: chatToLeadConversion,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const FirstResponseTime = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.FirstResponseTime(sec)'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName,
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.FirstResponseTime(sec)'),
            data: firstRespTime,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const AverageResponseTime = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.AverageResponseTime(sec)'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName,
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.AverageResponseTime(sec)'),
            data: avgRespTime,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const TimeOutChats = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.TimedOut-Chats'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName.map(m => m + " %"),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.TimedOut-Chats'),
            data: timeoutchat,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const AverageLoggedinTime = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.AverageLogged-Time'),
            style: {
                fontSize: '14px',
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        subtitle: {
            text: t('DashboardReports.DEPVSDealer-Managed(Graphs)'),
            align: 'center',
            style: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: companyName,
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            title: {
                text: t('GraphReports-label.Managed-By'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: t('GraphReports-label.Values'),
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
        },
        tooltip: {
            valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.4,
                borderWidth: 0
            }
        },
        series: [{
            name: t('GraphReports-label.AverageLogged-Time'),
            data: avgLoggedinTime,
            color: '#4e86c7'
        }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }

    const renderLoader = () => {
        return (
     
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE"  animationDuration=".5s" />
          
        );
    }

    return (
        <div >
            <div className="row p-2">
                <img id="logoImage" style={{ display: "none" }} src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" />
                <div className="wgreport-tab viewreport-box">
                    <div className="row view-wgreport ">
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                            <div className="spinner-box">
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="domainName"
                                value={selectedWebsite}
                                options={WebsiteArray}
                                onChange={onWebsiteChange}
                                optionLabel="domainName"
                                itemTemplate={WebsiteOptionTemplate}
                                placeholder={!loadingWebsite ? t('ReportComponent.Select Website') : selectedWebsite}
                            />
                            {loadingWebsite && renderLoader()}
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                            <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                maxDate={new Date()}
                            />
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                maxDate={new Date()}
                                minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                            />
                        </div>

                        <div className="col-md-3 py-1 text-right text-md-left">
                            {hidebutton == false ? <>   <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                <ProgressSpinner
                                    style={{ width: "25px", bottom: "10px" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                /> : t('wg-buttons.Export-PDF')}</button>
                            </> : ""}
                            <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="depManaged-report">
                <div className="row">
                    {loading == true ?
                        <ProgressSpinner
                            style={{ width: "50px", position: "relative", top: "10rem" }}
                            strokeWidth="3"
                            fill="#EEEEEE"
                            animationDuration=".5s"
                        />
                        : ""}
                    {data?.length > 0 && loading == false ? <>
                        <div id="section1" className="row">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="wgreport-span">{t('DashboardReports.DEPVSDealer-Managed(Graphs)')}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={VisitortoGreetCoversion}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={VisitortoChatConversion}
                                    />
                                </div>
                            </div>
                            <Divider />
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={ChatToLeadConversion}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={ChattoMeaningfulConversation}
                                    />
                                </div>
                            </div>
                            <Divider />
                        </div>
                        <div id="section2" className="row">
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={FirstResponseTime}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={AverageResponseTime}
                                    />
                                </div>
                            </div>
                            <Divider />
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={TimeOutChats}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card" style={{ width: "100%" }}>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={AverageLoggedinTime}
                                    />
                                </div>
                            </div>
                        </div>
                    </> : ""}
                </div>
            </div>
        </div >
    )
}
export default DepVsDealerManageGraph;